import { px, useMantineTheme } from "@mantine/core";
import { useElementSize, useMediaQuery } from "@mantine/hooks";

export function useIsMobile() {
  const { breakpoints } = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.sm})`);
  const isTablet = useMediaQuery(`(max-width: ${breakpoints.md})`);
  const isDesktop = useMediaQuery(`(max-width: ${breakpoints.lg})`);
  return { isMobile, isTablet, isDesktop };
}

export function useIsMobileContainer() {
  const { ref, width } = useElementSize();
  const { breakpoints } = useMantineTheme();
  const isMobileContainer = width < (px(breakpoints.sm) as number);
  const isTabletContainer = width < (px(breakpoints.md) as number);
  const isDesktopContainer = width < (px(breakpoints.lg) as number);
  return { ref, isMobileContainer, isTabletContainer, isDesktopContainer };
}
